<template>
    <div class="panel">
        <h3>Loan Type</h3>

        <Checkbox v-model="data.loan.enabled" density="compact"> Enable Loan Type </Checkbox>

        <TransitionExpand>
            <div class="panel-count" v-if="data.loan.enabled">
                <div class="panel-select">
                    <Select
                        v-model="data.loan.type"
                        :items="loanTypes"
                        label="Loan Type"
                        placeholder="Choose type" />
                </div>
            </div>
        </TransitionExpand>
    </div>

    <div class="panel">
        <h3>Affiliate</h3>

        <Checkbox v-model="data.affiliate.enabled" density="compact">
            Has affiliate data
        </Checkbox>

        <TransitionExpand>
            <div class="panel-count" v-if="data.affiliate.enabled">
                <div class="panel-text">
                    <Textbox
                        v-model="data.affiliate.affiliateId"
                        label="Affiliate Id"
                        placeholder="Example: 70108" />
                </div>

                <div class="panel-select">
                    <Select
                        v-model="data.affiliate.salesChannel"
                        :items="salesChannels"
                        label="Sales Channel"
                        placeholder="Choose type" />
                </div>

                <div class="panel-select">
                    <Select
                        v-model="data.affiliate.businessArea"
                        :items="businessAreas"
                        label="Business Area"
                        placeholder="Choose type" />
                </div>

                <div class="panel-text">
                    <Textbox
                        v-model="data.affiliate.groupName"
                        label="Group Name"
                        placeholder="Example: Idealo" />
                </div>

                <div class="panel-text">
                    <Textbox
                        v-model="bookingSalesChannelsText"
                        label="Booking sales channels"
                        placeholder="Example: default, planner" />
                    <em>
                        {{ data.bookingSalesChannels }}
                    </em>
                </div>
            </div>
        </TransitionExpand>
    </div>

    <div class="panel">
        <h3>Page data</h3>

        <div>
            <Checkbox v-model="data.hasBonusNights" density="compact">
                Has Bonus Nights
            </Checkbox>
            <Checkbox v-model="data.hasPaymentDiscount" density="compact">
                Has payment discount
            </Checkbox>
            <Checkbox v-model="data.hasCampaignDiscount" density="compact">
                Has campaign discount
            </Checkbox>
            <Checkbox v-model="data.hasAmountAlreadyPaid" density="compact">
                Has amount already paid
            </Checkbox>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType, computed, ref, watch } from 'vue';
    import { FakeDataCheckout } from '../DevPanel.interfaces';
    import {
        getBusinessAreaOptions,
        getSalesChannelsOptions,
        getLoanTypesOptions,
    } from '../DevPanel.helpers';
    import TransitionExpand from '@ui/components/TransitionExpand/TransitionExpand.vue';
    import Select from '@ui/components/FormV2/Fields/Select/Select.vue';
    import Checkbox from '@ui/components/FormV2/Fields/Checkbox/Checkbox.vue';
    import Textbox from '@ui/components/FormV2/Fields/Textbox/Textbox.vue';

    export default defineComponent({
        name: 'PaymentPanel',
        components: {
            TransitionExpand,
            Select,
            Textbox,
            Checkbox,
        },
        props: {
            data: {
                type: Object as PropType<FakeDataCheckout>,
                required: true,
            },
        },
        setup({ data }) {
            const bookingSalesChannelsText = ref<string>(
                data.bookingSalesChannels?.join(',')
            );

            watch(
                () => bookingSalesChannelsText.value,
                (value) => {
                    data.bookingSalesChannels = value.split(',');
                }
            );

            const loanTypes = computed(() => getLoanTypesOptions());
            const salesChannels = computed(() => getSalesChannelsOptions());
            const businessAreas = computed(() => getBusinessAreaOptions());

            return {
                bookingSalesChannelsText,
                loanTypes,
                salesChannels,
                businessAreas,
            };
        },
    });
</script>

<style lang="scss">
    @forward './Panel.scss';
</style>
